const isValidNumberInput = (number: any): boolean => typeof number === 'number' && number !== 0
export default isValidNumberInput
